module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Regular-6d68613508bebde9a33dbd3fc38bc3d6.woff2";